import { RunState } from "../state/RunState";
import { COMBO_DECAY_IDLE_MS, COMBO_DECAY_AMOUNT } from "../app/Config";

export class TimerSystem {
  private elapsedMs: number = 0;

  getElapsedMs(): number {
    return this.elapsedMs;
  }

  update(state: RunState, deltaMs: number): boolean {
    this.elapsedMs += deltaMs;

    // Combo decay
    const idleMs = this.elapsedMs - state.lastActivityTimeMs;
    if (idleMs > COMBO_DECAY_IDLE_MS && state.combo > 1) {
      state.combo = Math.max(1, state.combo - COMBO_DECAY_AMOUNT);
      state.lastActivityTimeMs = this.elapsedMs;
    }

    // Timer countdown
    state.timeRemainingMs -= deltaMs;
    if (state.timeRemainingMs <= 0) {
      state.timeRemainingMs = 0;
      return true; // time up
    }
    return false;
  }

  reset(): void {
    this.elapsedMs = 0;
  }
}
